var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.033,
    height: 44.998,
    viewBox: "0 0 45.033 44.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8457",
    "data-name": "\\uADF8\\uB8F9 8457",
    transform: "translate(-227.806 -220.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8456",
    "data-name": "\\uADF8\\uB8F9 8456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8451",
    "data-name": "\\uADF8\\uB8F9 8451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8450",
    "data-name": "\\uADF8\\uB8F9 8450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27131",
    "data-name": "\\uD328\\uC2A4 27131",
    d: "M254.311,240.49c2.1,0,4.1-.021,6.1.019.374.008.939.169,1.062.427a1.358,1.358,0,0,1-.308,1.11q-9.074,11.3-18.187,22.575c-.05.063-.086.155-.151.184-.354.162-.752.486-1.067.422-.589-.12-.478-.7-.375-1.136.264-1.113.577-2.213.865-3.32q2.007-7.727,4.009-15.453a1.652,1.652,0,0,0,0-.318h-4.788a9.483,9.483,0,0,1-1.36-.016c-.336-.049-.845-.169-.93-.39a1.294,1.294,0,0,1,.226-1.059c1.491-1.916,3.028-3.8,4.553-5.688q6.891-8.539,13.783-17.075c.033-.042.057-.106.1-.123.359-.142.722-.275,1.085-.411.116.374.385.777.321,1.116-.214,1.121-.55,2.218-.837,3.325Zm4.945,1.545c-.293-.027-.419-.049-.545-.049-1.683,0-3.366.007-5.048-.007-.941-.008-1.194-.352-.964-1.245q.957-3.709,1.918-7.418l2.289-8.867-.129-.074-15.426,19.133c2.056,0,3.867-.012,5.677.005.9.008,1.152.353.932,1.207q-1.358,5.255-2.719,10.507-.751,2.91-1.5,5.823l.132.062C248.972,254.791,254.067,248.47,259.256,242.035Z",
    fill: "#ffd400"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8453",
    "data-name": "\\uADF8\\uB8F9 8453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8452",
    "data-name": "\\uADF8\\uB8F9 8452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27132",
    "data-name": "\\uD328\\uC2A4 27132",
    d: "M232.017,234.423c-1.209,0-2.277.029-3.341-.019a1.092,1.092,0,0,1-.829-.412,1.077,1.077,0,0,1,.2-.917q5.088-6.238,10.239-12.425c.214-.255.708-.276,1.072-.406.11.37.386.782.305,1.1-.806,3.2-1.671,6.383-2.518,9.571-.034.126-.061.253-.125.522,1.035,0,2.012-.042,2.983.02.4.026,1.008.175,1.13.445a1.465,1.465,0,0,1-.364,1.168c-3.252,4-6.534,7.97-9.809,11.949-.119.144-.221.343-.376.407-.288.119-.715.309-.89.189a1.065,1.065,0,0,1-.373-.9c.411-1.762.9-3.506,1.36-5.256C231.111,237.822,231.549,236.181,232.017,234.423Zm6.9-1.454c-1.032,0-1.853.019-2.673,0-.8-.023-1.1-.437-.9-1.207.268-1.028.557-2.05.829-3.077.378-1.431.749-2.864,1.123-4.3l-.13-.052-7.1,8.635c1.041,0,1.868-.011,2.694,0,.795.014,1.058.335.9,1.119-.11.545-.277,1.079-.42,1.617l-1.533,5.762.14.077Z",
    fill: "#a4a7ac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8455",
    "data-name": "\\uADF8\\uB8F9 8455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8454",
    "data-name": "\\uADF8\\uB8F9 8454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27133",
    "data-name": "\\uD328\\uC2A4 27133",
    d: "M268.677,251.067c1.161,0,2.228-.029,3.29.019a1.1,1.1,0,0,1,.83.409,1.071,1.071,0,0,1-.189.916q-5.106,6.264-10.274,12.477a1.221,1.221,0,0,1-1.014.331c-.517-.122-.482-.62-.364-1.063l2.7-10.107c-.96,0-1.848.046-2.729-.017-.491-.036-1.16-.1-1.41-.418-.436-.553.2-1.008.536-1.423q4.768-5.815,9.563-11.61c.33-.4.6-1.087,1.307-.772.813.36.422,1.029.272,1.6-.786,2.98-1.585,5.957-2.376,8.935C268.764,250.544,268.737,250.754,268.677,251.067Zm-5.337,10.045.136.05,7.1-8.639c-.983,0-1.756.005-2.528,0-1.014-.007-1.28-.352-1.018-1.351.329-1.259.684-2.511,1.017-3.769.3-1.121.582-2.246.872-3.369l-.153-.057-7.026,8.544c.969,0,1.735-.007,2.5,0,1,.012,1.269.384,1.011,1.36Q264.3,257.5,263.34,261.112Z",
    fill: "#a4a7ac"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.fde30034217c219a69ce1744714d09ca.svg";
export { ForwardRef as ReactComponent };